var ArticleSubtitle = function ArticleSubtitle(_ref) {
  var subtitle = _ref.subtitle,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  if (!subtitle || subtitle.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "a__subtitle",
    style: style
  }, /*#__PURE__*/React.createElement("h4", null, subtitle));
};
export default ArticleSubtitle;